exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reimagine-portal-icon[data-v-28bd4407] {\n  width: 218px;\n  height: 70px;\n}\n@media only screen and (min-width: 0) and (max-width: 410px) {\n.responsive-reimagine-portal-icon[data-v-28bd4407] {\n    width: 150px;\n    height: 50px;\n}\n}\n", ""]);

// exports
